import { defineMessages, type MessageValue } from "react-intl"

const plain = defineMessages({
  Cancel: { defaultMessage: "Cancel", id: "47FYwb" },
  Reply: { defaultMessage: "Reply", id: "9HU8vw" },
  Send: { defaultMessage: "Send", id: "9WRlF4" },
  NotePlaceholder: { defaultMessage: "What's on your mind?", id: "flnGvv" },
  Back: { defaultMessage: "Back", id: "cyR7Kh" },
  Block: { defaultMessage: "Block", id: "Up5U7K" },
  Unblock: { defaultMessage: "Unblock", id: "nDejmx" },
  Mute: { defaultMessage: "Mute", id: "x82IOl" },
  MutedAuthor: { defaultMessage: "This author has been muted", id: "ASRK0S" },
  Show: { defaultMessage: "Show", id: "K7AkdL" },
  Delete: { defaultMessage: "Delete", id: "K3r6DQ" },
  Deleted: { defaultMessage: "Deleted", id: "KQvWvD" },
  Unmute: { defaultMessage: "Unmute", id: "W9355R" },
  MuteAll: { defaultMessage: "Mute all", id: "cWx9t8" },
  JustNow: { defaultMessage: "Just now", id: "bxv59V" },
  Follow: { defaultMessage: "Follow", id: "ieGrWo" },
  FollowAll: { defaultMessage: "Follow all", id: "mKAr6h" },
  Unfollow: { defaultMessage: "Unfollow", id: "izWS4J" },
  FollowsYou: { defaultMessage: "follows you", id: "FmXUJg" },
  Invoice: { defaultMessage: "Lightning Invoice", id: "9wO4wJ" },
  PayInvoice: { defaultMessage: "Pay Invoice", id: "lvlPhZ" },
  Expired: { defaultMessage: "Expired", id: "RahCRH" },
  Pay: { defaultMessage: "Pay", id: "lD3+8a" },
  Loading: { defaultMessage: "Loading...", id: "gjBiyj" },
  Logout: { defaultMessage: "Logout", id: "C81/uG" },
  ShowMore: { defaultMessage: "Show more", id: "aWpBzj" },
  TranslationFailed: { defaultMessage: "Translation failed", id: "qmJ8kD" },
  Reactions: { defaultMessage: "Reactions", id: "XgWvGA" },
  Share: { defaultMessage: "Share", id: "OKhRC6" },
  CopyID: { defaultMessage: "Copy ID", id: "wtLjP6" },
  CopyJSON: { defaultMessage: "Copy Event JSON", id: "P61BTu" },
  DislikeAction: { defaultMessage: "Dislike", id: "4OB335" },
  Zapped: { defaultMessage: "zapped", id: "B6+XJy" },
  NoteToSelf: { defaultMessage: "Note to Self", id: "4rYCjn" },
  Read: { defaultMessage: "Read", id: "filwqD" },
  Write: { defaultMessage: "Write", id: "k2veDA" },
  LNURLFail: { defaultMessage: "Failed to load LNURL service", id: "zonsdq" },
  InvalidLNURL: { defaultMessage: "Invalid LNURL", id: "0jOEtS" },
  InvoiceFail: { defaultMessage: "Failed to load invoice", id: "CHTbO3" },
  Custom: { defaultMessage: "Custom", id: "Sjo1P4" },
  Confirm: { defaultMessage: "Confirm", id: "N2IrpM" },
  Comment: { defaultMessage: "Comment", id: "LgbKvU" },
  SendZap: { defaultMessage: "Send zap", id: "5ykRmX" },
  ShowReplies: { defaultMessage: "Show replies", id: "hicxcO" },
  TooShort: { defaultMessage: "name too short", id: "B4C47Y" },
  TooLong: { defaultMessage: "name too long", id: "8g2vyB" },
  Regex: { defaultMessage: "name has disallowed characters", id: "0mch2Y" },
  Registered: { defaultMessage: "name is registered", id: "cuV2gK" },
  Disallowed: { defaultMessage: "name is blocked", id: "wih7iJ" },
  DisalledLater: { defaultMessage: "name will be available later", id: "HFls6j" },
  BuyNow: { defaultMessage: "Buy Now", id: "lCILNz" },
  NotAvailable: { defaultMessage: "Not available:", id: "MI2jkA" },
  OrderPaid: { defaultMessage: "Order Paid!", id: "H6/kLh" },
  NewNip: { defaultMessage: "Your new NIP-05 handle is:", id: "4L2vUY" },
  ActivateNow: { defaultMessage: "Activate Now", id: "ZKORll" },
  AddToProfile: { defaultMessage: "Add to Profile", id: "qkvYUb" },
  AccountPage: { defaultMessage: "account page", id: "lgg1KN" },
  AccountSupport: { defaultMessage: "Account Support", id: "/JE/X+" },
  GoTo: { defaultMessage: "Go to", id: "xIoGG9" },
  SavePassword: {
    defaultMessage: "Please make sure to save the following password in order to manage your handle in the future",
    id: "+vIQlC",
  },
  Handle: { defaultMessage: "Handle", id: "iNWbVV" },
  Pin: { defaultMessage: "Pin", id: "puLNUJ" },
  Pinned: { defaultMessage: "Pinned", id: "fWZYP5" },
  Bookmark: { defaultMessage: "Bookmark", id: "Rs4kCE" },
  Bookmarks: { defaultMessage: "Bookmarks", id: "nGBrvw" },
  Bookmarked: { defaultMessage: "Saved", id: "fsB/4p" },
  All: { defaultMessage: "All", id: "zQvVDJ" },
  ConfirmUnbookmark: { defaultMessage: "Are you sure you want to remove this note from bookmarks?", id: "1Mo59U" },
  ConfirmUnpin: { defaultMessage: "Are you sure you want to unpin this note?", id: "IEwZvs" },
  ReBroadcast: { defaultMessage: "Broadcast Again", id: "c3g2hL" },
  IrisUserNameLengthError: { defaultMessage: "Name must be between 8 and 15 characters", id: "LhLvRx" },
  IrisUserNameFormatError: { defaultMessage: "Username must only contain lowercase letters and numbers", id: "RSr2uB" },
  InvalidNip05Address: { defaultMessage: "Invalid Nostr Address", id: "P2o+ZZ" },
  ErrorValidatingNip05Address: { defaultMessage: "Cannot verify Nostr Address", id: "LmdPXO" },
  InvalidLud16: { defaultMessage: "Invalid Lightning Address", id: "GqQeu/" },
})

const withArgs = defineMessages<{
  MuteCount: { n: number }
  Others: { n: number }
  BlockCount: { n: number }
  FollowerCount: { n: number }
  FollowingCount: { n: number }
  TranslateTo: { lang: string }
  TranslatedFrom: { lang: string }
  UnknownEventKind: { kind: number }
  ConfirmDeletion: { id: string }
  ConfirmRepost: { id: string }
  ReactionsCount: { n: number }
  Dislike: { n: number }
  Sats: { n: number | string }
  OthersZapped: { n: number }
  Likes: { n: number }
  Zaps: { n: number }
  Dislikes: { n: number }
  Reposts: { n: number }
  Seconds: { n: number }
  Milliseconds: { n: number }
  ShowLatest: { n: number }
  Buying: { item: string }
  FindMore: { service: string; link: MessageValue }
  BookmarksCount: { n: number }
  ReactionsLink: { n: number }
  UserNameLengthError: { limit: number }
  AboutLengthError: { limit: number }
}>({
  MuteCount: { defaultMessage: "{n} muted", id: "VlJkSk" },
  Others: { defaultMessage: ` & {n} {n, plural, =1 {other} other {others}}`, id: "egib+2" },
  BlockCount: { defaultMessage: "{n} blocked", id: "nwZXeh" },
  FollowerCount: { defaultMessage: "{n} followers", id: "o7e+nJ" },
  FollowingCount: { defaultMessage: "Follows {n}", id: "9SvQep" },
  TranslateTo: { defaultMessage: "Translate to {lang}", id: "Ebl/B2" },
  TranslatedFrom: { defaultMessage: "Translated from {lang}", id: "Cu/K85" },
  UnknownEventKind: { defaultMessage: "Unknown event kind: {kind}", id: "KahimY" },
  ConfirmDeletion: { defaultMessage: `Are you sure you want to delete {id}`, id: "RhDAoS" },
  ConfirmRepost: { defaultMessage: `Are you sure you want to repost: {id}`, id: "+D82kt" },
  ReactionsCount: { defaultMessage: "Reactions ({n})", id: "iCqGww" },
  Dislike: { defaultMessage: "{n} Dislike", id: "GspYR7" },
  Sats: { defaultMessage: `{n} {n, plural, =1 {sat} other {sats}}`, id: "jA3OE/" },
  OthersZapped: { defaultMessage: `{n, plural, =0 {} =1 {zapped} other {zapped}}`, id: "mKhgP9" },
  Likes: { defaultMessage: "Likes ({n})", id: "6ewQqw" },
  Zaps: { defaultMessage: "Zaps ({n})", id: "JHEHCk" },
  Dislikes: { defaultMessage: "Dislikes ({n})", id: "2k0Cv+" },
  Reposts: { defaultMessage: "Reposts ({n})", id: "8/vBbP" },
  Seconds: { defaultMessage: "{n} secs", id: "0yO7wF" },
  Milliseconds: { defaultMessage: "{n} ms", id: "/n5KSF" },
  ShowLatest: { defaultMessage: "Show latest {n} notes", id: "DZzCem" },
  Buying: { defaultMessage: "Buying {item}", id: "MzRYWH" },
  FindMore: { defaultMessage: "Find out more info about {service} at {link}", id: "wqyN/i" },
  BookmarksCount: { defaultMessage: "Bookmarks ({n})", id: "GL8aXW" },
  ReactionsLink: { defaultMessage: "{n} Reactions", id: "jzgQ2z" },
  UserNameLengthError: { defaultMessage: "Name must be less than {limit} characters", id: "u9NoC1" },
  AboutLengthError: { defaultMessage: "About must be less than {limit} characters", id: "DrZqav" },
})

export default { ...plain, ...withArgs }
